import { Descriptions } from "antd";
import { useState, useEffect } from "react";
import { arrPartners } from "../data/arrPartners";
import { useParams } from "react-router-dom";

function Partner() {
  const [partners, setPartners] = useState(arrPartners);
  const [partner, setPartner] = useState({});

  const { id } = useParams();

  useEffect(() => {
    const _partners = partners.filter((partner) => {
      return partner.id.toString() === id;
    });
    setPartner(_partners[0]);
    console.log(partner);
  }, []);

  return (
    <main>
      <section className="partner">
        <header>
          <img
            alt={partner.title}
            src={"/images/partners/" + partner.logo}
            className="logo"
          />
        </header>
        <div className="wrapper">
          <div className="card">
            <div className="title">
              <h1>
                {partner.title} <span>{"( " + partner.country + " )"}</span>
              </h1>
            </div>
            <div className="info">
              <Descriptions title="Partner Info" items={partner.items} />
            </div>
            {partner.descriptions && (
              <div className="descriptions">
                {partner.descriptions.map((description) => {
                  return <p key={description.id}>{description.text}</p>;
                })}
              </div>
            )}
            {partner.tasks && (
              <div className="tasks">
                {partner.tasks.length > 0 && <p>Other tasks,</p>}
                <ul style={{ marginLeft: 32 }}>
                  {partner.tasks.map((task) => {
                    return <li key={task.id}>{task.text}</li>;
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Partner;
